class CollectionPriceCalculator {
  constructor() {
    this.init();
  }

  init() {
    document.querySelectorAll('.price-list--collection').forEach(priceList => {
      const productId = priceList.dataset.productId;
      const discountRate = parseFloat(priceList.dataset.discountRate);
      
      if (productId && discountRate) {
        this.setupPriceObserver(priceList, productId, discountRate);
      }
    });
  }

  setupPriceObserver(priceList, productId, discountRate) {
    const originalPrice = priceList.querySelector('.original-price');
    const discountedPrice = priceList.querySelector('.discounted-price');
    
    if (originalPrice && discountedPrice) {
      const variantChangeEvent = new CustomEvent('variant:change', {
        detail: { productId: productId }
      });

      document.addEventListener('variant:change', (e) => {
        if (e.detail.productId === productId) {
          const originalCents = parseFloat(e.detail.price);
          const discountedCents = Math.ceil(originalCents * (100 - discountRate) / 100);

          originalPrice.innerHTML = Shopify.formatMoney(originalCents);
          discountedPrice.innerHTML = Shopify.formatMoney(discountedCents);
        }
      });
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CollectionPriceCalculator();
});
